import { render, staticRenderFns } from "./comments-form.vue?vue&type=template&id=dac278f2"
import script from "./comments-form.vue?vue&type=script&lang=ts"
export * from "./comments-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports